import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { Box, Button, Modal, styled, SxProps } from '@mui/material';
import { ResourceBudgetProposalAssociationT } from 'routes/BudgetModule/config/types';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { CreateDraftOperationName } from './CreateDraftOperationName';
import { CreateDraftOperationAssociations } from './CreateDraftOperationAssociations';
import { useCreateDraftOperationMutation } from '../hooks';
import { BudgetBys } from 'business/constants';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

const StyModal = styled(Box, {
    name: 'StyModal',
})({
    minWidth: '800px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '4px',
    boxShadow:
        '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
});

export const CreateDraftOperation: React.FC<{
    exercice: number;
    budgetBy: BudgetBys;
    disabled?: boolean;
    isDafView?: boolean;
    sx?: SxProps;
}> = ({ exercice, budgetBy, disabled, isDafView = false, sx = {} }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const [step, setStep] = useState(1);
    const [name, setName] = useState('');
    const [associations, setAssociations] = useState<
        ResourceBudgetProposalAssociationT[]
    >([]);

    const resetModal = () => {
        setShowModal(false);
        setStep(1);
        setName('');
        setAssociations([]);
    };

    const createDraftOperationMutation = useCreateDraftOperationMutation({
        name,
        associations,
        resetModal,
    });

    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();

    return (
        <>
            <Button
                variant="contained"
                disabled={disabled}
                sx={{
                    height: '26px',
                    minHeight: '26px',
                    ...sx,
                }}
                onClick={() => {
                    trackEventBudget(
                        isDafView
                            ? TRACKABLE_EVENTS.budget.budgetOverview.operations
                                  .draftOperation.create
                            : TRACKABLE_EVENTS.budget.budgetProposal
                                  .draftOperation.create,
                        {
                            exercice,
                        },
                    );
                    setShowModal(true);
                }}
                startIcon={<AddIcon fontSize="small" />}
            >
                {t('budgetOverview.createMantySecondaryBudgetAxisElement', {
                    context: sourceTable,
                })}
            </Button>
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <StyModal>
                    {step === 1 && (
                        <CreateDraftOperationName
                            closeModal={resetModal}
                            setStep={setStep}
                            name={name}
                            setName={setName}
                        />
                    )}
                    {step === 2 && (
                        <CreateDraftOperationAssociations
                            createDraftOperation={
                                createDraftOperationMutation.mutate
                            }
                            associations={associations}
                            setAssociations={setAssociations}
                            closeModal={resetModal}
                            exercice={exercice}
                            isDafView={isDafView}
                            budgetBy={budgetBy}
                        />
                    )}
                </StyModal>
            </Modal>
        </>
    );
};
